import { Fragment } from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { isEmpty } from 'lodash-es';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const AuditPlaces = ({ ...logEntry }) => {
    if (isEmpty(logEntry.auditPlaces)) {
        return <span className="text-muted">-</span>;
    }

    // Only display the first 3
    const displayPlaces = logEntry.auditPlaces.slice(0, 3);
    const remainingCount = logEntry.auditPlaces.length - 3;

    return (
        <div className="d-flex flex-wrap align-items-end">
            {displayPlaces.map((place, pIndex) => (
                <Fragment key={place.id}>
                    <div
                        id={`audit-place-${place.id}`}
                        className={pIndex !== displayPlaces.length - 1 ? 'mr-2' : ''}
                    >
                        {place.icon ? (
                            <img
                                src={place.icon}
                                alt={place.name}
                                className="place-icon"
                            />
                        ) : (
                            <FontAwesomeIcon icon={faMapMarkerAlt} />
                        )}
                    </div>

                    <UncontrolledTooltip target={`audit-place-${place.id}`}>
                        {place.name || 'Location'}
                    </UncontrolledTooltip>
                </Fragment>
            ))}

            {remainingCount > 0 && (
                <small className="text-muted ml-2">
                    (+{remainingCount} more)
                </small>
            )}
        </div>
    );
};